import { ApplicationRef, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';

import { rootReducer } from './search-all.store';

import { ConfigModule } from 'Angular/config/config.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { SimplePaginationControlsModule } from 'Angular/features/components/pagination/simple-pagination-controls/simple-pagination-controls.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { PopoverModule } from 'Angular/features/directives/popovers/popover/popover.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';

import { SearchAllCategoriesComponent } from './components/search-all-categories/search-all-categories.component';
import { SearchAllInputComponent } from './components/search-all-input/search-all-input.component';
import { SearchAllPageComponent } from './components/search-all-page/search-all-page.component';
import { SearchAllTableComponent } from './components/search-all-table/search-all-table.component';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';

import { getLogger } from 'Angular/state/logger';

@NgModule({
    declarations: [
        SearchAllCategoriesComponent,
        SearchAllInputComponent,
        SearchAllPageComponent,
        SearchAllTableComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        TooltipModule,
        ConfigModule,
        IconModule,
        NavigationModule,
        PopoverModule,
        RouterModule.forRoot([], { useHash: true }),
        SimplePaginationControlsModule,
        StoreModule.forRoot({ reducers: rootReducer }, { metaReducers: getLogger() }),
    ],
})
export class AppModule {
    ngDoBootstrap(appRef: ApplicationRef): void {
        appRef.bootstrap(SearchAllPageComponent);
        appRef.bootstrap(TopBarNavComponent);
    }
}
